import { FC, ReactNode } from 'react';

type Props = {
    leftContent?: ReactNode;
    rightContent?: ReactNode;
};

const TabContentHeader: FC<Props> = ({ leftContent, rightContent }) => {
    return (
        <div className="flex justify-between px-4 py-2">
            <div>{leftContent}</div>
            <div>{rightContent}</div>
        </div>
    );
};

export default TabContentHeader;
